import { FEATURE_CTA_EVENT_TYPE, trackFeatureCta } from 'analytics/feature-cta-tracking';

const FEATURE_CAROUSEL = 'carosel_cta';

export function trackShopRegularItemsCtaImpression({
  title,
  linkUrl,
  linkText,
}: {
  title: string;
  linkUrl: string;
  linkText: string;
}) {
  trackFeatureCta({
    eventType: FEATURE_CTA_EVENT_TYPE.IMPRESSION,
    feature: FEATURE_CAROUSEL,
    featureCtaId: `${title} ${linkText}`,
    linkText,
    linkUrl,
  });
}

export function trackShopRegularItemsCtaClick({
  title,
  linkUrl,
  linkText,
}: {
  title: string;
  linkUrl: string;
  linkText: string;
}) {
  trackFeatureCta({
    eventType: FEATURE_CTA_EVENT_TYPE.CLICK,
    feature: FEATURE_CAROUSEL,
    featureCtaId: `${title} ${linkText}`,
    linkText,
    linkUrl,
  });
}
